const StrugglingToConnectSvg = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
   >
      <g clipPath="url(#clip0_66_194)">
         <path
            d="M1.99993 5.13779C1.99993 3.29645 3.49193 1.80445 5.33326 1.80445C7.1746 1.80445 8.6666 3.29645 8.6666 5.13779C8.6666 6.97912 7.1746 8.47112 5.33326 8.47112C3.49193 8.47112 1.99993 6.97912 1.99993 5.13779ZM11.9999 25.8045V23.1378H3.99993V27.1378C3.99993 27.2805 3.97593 27.4231 3.9306 27.5591L2.59726 31.5591C2.36526 32.2645 1.59193 32.6338 0.910597 32.4018C0.213264 32.1698 -0.165403 31.4151 0.0679302 30.7151L1.33193 26.9205V13.8045C1.33193 11.5991 3.1266 9.80445 5.33193 9.80445H11.8106C12.0906 9.80445 12.3586 9.71912 12.5853 9.55645L16.1159 7.03379C16.7959 3.30712 20.0599 0.469788 23.9799 0.469788C28.3919 0.469788 31.9799 4.05779 31.9799 8.46979C31.9799 12.8818 28.3919 16.4698 23.9799 16.4698C20.1839 16.4698 17.0039 13.8098 16.1879 10.2578L14.1346 11.7245C13.4533 12.2111 12.6506 12.4698 11.8106 12.4698H9.33193V20.4698H11.9986C13.4693 20.4698 14.6653 21.6658 14.6653 23.1365V25.8031C14.6653 26.5405 14.0693 27.1365 13.3319 27.1365C12.5946 27.1365 11.9986 26.5405 11.9986 25.8031L11.9999 25.8045ZM18.6479 8.47112C18.6479 11.4125 21.0399 13.8045 23.9813 13.8045C26.9226 13.8045 29.3146 11.4125 29.3146 8.47112C29.3146 5.52979 26.9226 3.13779 23.9813 3.13779C21.0399 3.13779 18.6479 5.52979 18.6479 8.47112ZM3.99993 20.4711H6.6666V12.4711H5.33326C4.59726 12.4711 3.99993 13.0685 3.99993 13.8045V20.4711ZM29.9066 18.0431L12.5733 30.0711C11.9693 30.4898 11.8186 31.3218 12.2386 31.9271C12.6613 32.5351 13.4959 32.6791 14.0946 32.2618L31.4279 20.2338C32.0319 19.8151 32.1826 18.9831 31.7626 18.3778C31.3439 17.7738 30.5119 17.6231 29.9066 18.0431Z"
            fill="#FF6D99"
         />
      </g>
      <defs>
         <clipPath id="clip0_66_194">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0 0.471252)"
            />
         </clipPath>
      </defs>
   </svg>
)

export default StrugglingToConnectSvg
